/** Finds the lowest vendor price amongst the provided vendor options */
export default function findLowestVendorPrice(vendorOptions: VendorOptionState[]): number {
  const isLowestVendor = vendorOptions.find((vendor) => {
    return vendor.isLowestPrice;
  });

  if (isLowestVendor) {
    return isLowestVendor.chosenPriceBreakUnitPrice;
  }

  return 0;
}
